var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"viodes",staticClass:"video-box-item",attrs:{"controls":"","src":"https://oss.yanxin7.cn/2023-08-10/3bd0fce05de43590663defdb44815b98"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }